import { create as a } from "zustand";
import { devtools as p } from "zustand/middleware";
import { immer as s } from "zustand/middleware/immer";
const i = {
  workerRef: null
}, S = a()(
  s(
    p(
      (t, l) => ({
        maps: {},
        actions: {
          initMapStore: (e) => {
            t(
              (o) => {
                o.maps[e] = i;
              },
              !1,
              `initMapStore - ${e}`
            );
          },
          deleteMapStore: (e) => {
            t(
              (o) => {
                delete o.maps[e];
              },
              !1,
              `deleteMapStore - ${e}`
            );
          },
          setWorkerRef: ({ mapId: e, workerRef: o }) => {
            t(
              (r) => {
                r.maps[e].workerRef = o;
              },
              !1,
              `setWorkerRef - ${e}`
            );
          }
        }
      }),
      {
        name: "PLMapboxStoreExp",
        enabled: !1
      }
    )
  )
);
export {
  S as usePLMapboxStoreExp
};
//# sourceMappingURL=index.es40.js.map
